import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { ComponentCanDeactivate } from '../../PendingChangesGuard ';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { EmppayComponent } from '../../emppay/emppay.component';
import { EmpdocumentComponent } from '../../empdocument/empdocument.component';
import { EmpassetComponent } from '../../empasset/empasset.component';
import { EmpskillsComponent } from '../../empskills/empskills.component';
import { AddemppopComponent } from '../addemppop/addemppop.component';
import { TextFieldModule } from '@angular/cdk/text-field';
import { DocumentComponent } from '../../document/document.component';
import { Subject } from 'rxjs';
import { AddpaymodepopupComponent } from '../../generalpopup/addpaymodepopup/addpaymodepopup.component';
import { AddpayrolegrppopupComponent } from '../../generalpopup/addpayrolegrppopup/addpayrolegrppopup.component';
import { AddpaytypepopupComponent } from '../../generalpopup/addpaytypepopup/addpaytypepopup.component';
import { AddwpsgrouppopupComponent } from '../../generalpopup/addwpsgrouppopup/addwpsgrouppopup.component';
import { AddbankbranchpopupComponent } from '../../generalpopup/addbankbranchpopup/addbankbranchpopup.component';
import { AddhiresourcepopupComponent } from '../../generalpopup/addhiresourcepopup/addhiresourcepopup.component';
import { AddemptypepopupComponent } from '../../generalpopup/addemptypepopup/addemptypepopup.component';
import { AddcontracttypepopupComponent } from '../../generalpopup/addcontracttypepopup/addcontracttypepopup.component';
import { AddcategorypopupComponent } from '../../generalpopup/addcategorypopup/addcategorypopup.component';
import { AdddepartmentpopupComponent } from '../../generalpopup/adddepartmentpopup/adddepartmentpopup.component';
import { AdddesignationpopupComponent } from '../../generalpopup/adddesignationpopup/adddesignationpopup.component';
import { AddgradepopupComponent } from '../../generalpopup/addgradepopup/addgradepopup.component';
import { AddlocationpopupComponent } from '../../generalpopup/addlocationpopup/addlocationpopup.component';
import { AddsponserpopupComponent } from '../../generalpopup/addsponserpopup/addsponserpopup.component';
import { AddaccomtypepopupComponent } from '../../generalpopup/addaccomtypepopup/addaccomtypepopup.component';
import { AddbranchpopupComponent } from '../../generalpopup/addbranchpopup/addbranchpopup.component';

@Component({
  selector: 'app-addempview',
  templateUrl: './addempview.component.html',
  styleUrls: ['./addempview.component.css']
})
export class AddempviewComponent implements OnInit, ComponentCanDeactivate, AfterViewInit {

  @ViewChild('documentbar', { static: false }) documentbar;

  // @ViewChild('defaultinput', { static: false }) inputEl: ElementRef;


  formname: string = "Employee";
  trxtype: string = "EMPLOYEE";
  //Display
  formmode: string = "Add";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;
  isempcodemode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  iseditempmain: boolean = false;

  isaddempasset: boolean = false;
  iseditempasset: boolean = false;
  isdeleteempasset: boolean = false;

  isaddemppay: boolean = false;
  iseditemppay: boolean = false;
  isdeleteemppay: boolean = false;

  isaddempskills: boolean = false;
  iseditempskills: boolean = false;
  isdeleteempskills: boolean = false;

  ismanualclose: boolean = false;

  isemphide: boolean = false;

  isemployeetypeaddmode: boolean = false;
  iscontracttypeaddmode: boolean = false;
  iscategoryaddmode: boolean = false;
  isdesignationaddmode: boolean = false;
  isdepartmentaddmode: boolean = false;
  isgradeaddmode: boolean = false;
  isbranchaddmode: boolean = false;
  issponseraddmode: boolean = false;
  isaccomtypeaddmode: boolean = false;
  islocationaddmode: boolean = false;
  ishiresourceaddmode: boolean = false;
  ispaymodeaddmode: boolean = false;
  ispayrollgrpaddmode: boolean = false;
  ispaytypeaddmode: boolean = false;
  iswpsgroupaddmode: boolean = false;
  isbankbranchaddmode: boolean = false;
  //Filter
 
  filterdesignationid: any = null;
  filterdesignationname: any = null;
  filterpayrollgrpid: any = null;
  filterpayrollgrpname: any = null;
  filterbranchid: any = null;
  filterbranchname: any = null;
  filterdepartmentid: any = null;
  filterdepartmentname: any = null;
  filterlocationid: any = null;
  filterlocationname: any = null;
  filternationalityid: any = null;
  filternationalityname: any = null;
  //Save Validation
  submitted: boolean;
  successfully: boolean;

  istds: boolean = false;
  ispf: boolean = false;
  isesi: boolean = false;
  isprofessionaltax: boolean = false;

  //set image
  image;
  strImage: any;
  picurl: string = "";
  picname: string = "";


  //Master
  genderColl: any = [];
  maritalstatusColl: any = [];
  nationalityColl: any = [];
  relationshipColl: any = [];
  paymodeColl: any = [];
  payrollgrpColl: any = [];
  emptypeColl: any = [];
  relievetypeColl: any = [];
  departmentColl: any = [];
  designationColl: any = [];
  gradeColl: any = [];
  branchColl: any = [];
  locationColl: any = [];

  religionColl: any = [];
  bloodgroupColl: any = [];
  sponserColl: any = [];
  contracttypeColl: any = [];
  categoryColl: any = [];
  paytypeColl: any = [];
  wpsgroupColl: any = [];
  bankbranchColl: any = [];
  reportingmanagerColl: any = [];
  approvalmanagerColl: any = [];
  statusColl: any = [];
  leavepolicyColl: any = [];
  accomtypeColl: any = [];
  salutionColl: any = [];
  hiresourceColl: any = [];
  settingsColl: any = [];
  expensepolicyColl: any = [];


  //Edit Get Values
  empBO: any = {};
  empColl: any = [];
  emppayColl: any = [];
  empdocumentColl: any = [];
  empassetColl: any = [];
  empskillsColl: any = [];
  //Trans
  emploanColl: any = [];
  empadvanceColl: any = [];
  empbonusColl: any = [];
  empreimburseColl: any = [];
  emptransferColl: any = [];
  empfineColl: any = [];
  emptemptransferColl: any = [];
  emptemptransferBO: any = {};
  empstatusColl: any = [];
  empstatusBO: any = {};
  
  
  empid: number = 0

  empnextpreviousColl: any = [];

  empform = new FormGroup({
    empid: new FormControl(0),
    empcode: new FormControl('', Validators.required),
    empname: new FormControl('', Validators.required),
    fathername: new FormControl(''),
    mothername: new FormControl(''),
    spousename: new FormControl(''),
    presentaddress: new FormControl(''),
    mobile: new FormControl(''),
    altmobile: new FormControl(''),
    permanantaddress: new FormControl(''),
    permcontactnum: new FormControl(''),
    relationname: new FormControl(''),
    relationmobile: new FormControl(''),
    emailid: new FormControl(''),
    staffcode: new FormControl('', Validators.required),
    lastname: new FormControl(''),
    personalemailid: new FormControl(''),
    recommandby: new FormControl(''),
    remarks: new FormControl(''),
    passportnumber: new FormControl(''),
    visanumber: new FormControl(''),
    emiratesid: new FormControl(''),
    bankaccno: new FormControl(''),
    iban: new FormControl(''),
    labourid: new FormControl(''),
    personcode: new FormControl(''),
    accomdetails: new FormControl(''),
    joindt: new FormControl(''),
    probationdt: new FormControl(''),
    relievedt: new FormControl(''),
    dob: new FormControl(''),
    confirmdt: new FormControl(''),
    passportexpdt: new FormControl(''),
    visaexpdt: new FormControl(''),
    emiratesidexpdt: new FormControl(''),
    labourexpdt: new FormControl(''),
    genderid: new FormControl(null),
    maritalstatusid: new FormControl(null),
    nationalityid: new FormControl(null),
    relationshipid: new FormControl(null),
    paymodeid: new FormControl(null),
    payrollgrpid: new FormControl(null),
    emptypeid: new FormControl(null),
    relievetypeid: new FormControl(null),
    departmentid: new FormControl(null),
    designationid: new FormControl(null),
    gradeid: new FormControl(null),
    branchid: new FormControl(null),
    locationid: new FormControl(null),
    religionid: new FormControl(null),
    bloodgroupid: new FormControl(null),
    sponserid: new FormControl(null),
    contracttypeid: new FormControl(null),
    categoryid: new FormControl(null),
    paytypeid: new FormControl(null),
    wpsgroupid: new FormControl(null),
    bankid: new FormControl(null),
    reportingmanagerid: new FormControl(null),
    approvalmanagerid: new FormControl(null),
    noticeperiod: new FormControl(null),
    statusid: new FormControl(null),
    leavepolicyid: new FormControl(null),
    salutionid: new FormControl(null),
    hiresourceid: new FormControl(null),
    accomtypeid: new FormControl(null),
    obdate: new FormControl(null),
    albalance: new FormControl(null),
    lpbalance: new FormControl(null),
    airticketbalance: new FormControl(null),
    lpamount: new FormControl(null),
    airticketamount: new FormControl(null),
    isesi: new FormControl(false),
    ispf: new FormControl(false),
    isprofessionaltax: new FormControl(false),
    istds: new FormControl(false),
    bankbranchid: new FormControl(null),
    esino: new FormControl(''),
    pfno: new FormControl(''),
    tdsno: new FormControl(''),
    panno: new FormControl(''),
    emppic: new FormControl(''),
    empimage: new FormControl(null),
    expensepolicyid: new FormControl(null),
    visadesignationid: new FormControl(null),
    isdraft: new FormControl(false),
    inactive: new FormControl(false),
  });

  totallowanceamt: any = 0
  totdeductionamt: any = 0
  totsalaryamt: any = 0

  editformtype: string = "";

  //show data
  designationname: string = "";
  marritalstatusname: string = "";

  currentmenu: string = "GENERAL";

  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private productFindService: NgbModal, private datePipe: DatePipe,
    private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.eid !== undefined) {
        this.empid = params.eid
      }
    });
    this.fnGetParameterVariable();
    this.fnServiceChanges();
  }
//Get Para
fnGetParameterVariable() {
  this.route.queryParams.subscribe(params => {
    if (params.designationid !== undefined) {
      this.filterdesignationid = params.designationid
    }

    if (params.designationname !== undefined) {
      this.filterdesignationname = params.designationname
    }
    if (params.payrollgrpid !== undefined) {
      this.filterpayrollgrpid = params.payrollgrpid
    }

    if (params.payrollgrpname !== undefined) {
      this.filterpayrollgrpname = params.payrollgrpname
    }
    if (params.branchid !== undefined) {
      this.filterbranchid = params.branchid
    }

    if (params.branchname !== undefined) {
      this.filterbranchname = params.branchname
    }
    if (params.departmentid !== undefined) {
      this.filterdepartmentid = params.departmentid
    }

    if (params.departmentname !== undefined) {
      this.filterdepartmentname = params.departmentname
    }
    if (params.locationid !== undefined) {
      this.filterlocationid = params.locationid
    }

    if (params.locationname !== undefined) {
      this.filterlocationname = params.locationname
    }
    if (params.nationalityid !== undefined) {
      this.filternationalityid = params.nationalityid
    }

    if (params.nationalityname !== undefined) {
      this.filternationalityname = params.nationalityname
    }


  })
}

  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }



  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.empform.reset();
      this.fnInitializeFormGroup();

      if (this.empid > 0) {
        this.fngetEmp();
      }

      this.fnLoadMaster();

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.empid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')

      if (!_check) {
        _check = this.loginService.fnCheckUserRoleAction(this.formname, 'VIEW')
      }

    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }


    this.iseditempmain = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER');

    this.isaddempasset = this.loginService.fnCheckUserRoleAction("EmployeeAsset", 'CREATE');
    this.iseditempasset = this.loginService.fnCheckUserRoleAction("EmployeeAsset", 'ALTER');
    this.isdeleteempasset = this.loginService.fnCheckUserRoleAction("EmployeeAsset", 'DELETE');


    this.isaddemppay = this.loginService.fnCheckUserRoleAction("EmployeePay", 'CREATE');
    this.iseditemppay = this.loginService.fnCheckUserRoleAction("EmployeePay", 'ALTER');
    this.isdeleteemppay = this.loginService.fnCheckUserRoleAction("EmployeePay", 'DELETE');


    this.isaddempskills = this.loginService.fnCheckUserRoleAction("EmployeeSkills", 'CREATE');
    this.iseditempskills = this.loginService.fnCheckUserRoleAction("EmployeeSkills", 'ALTER');
    this.isdeleteempskills = this.loginService.fnCheckUserRoleAction("EmployeeSkills", 'DELETE');

    this.isemployeetypeaddmode= this.loginService.fnCheckUserRoleAction("EmpType", 'CREATE')
    this.iscontracttypeaddmode= this.loginService.fnCheckUserRoleAction("ContractType", 'CREATE')
    this.iscategoryaddmode= this.loginService.fnCheckUserRoleAction("Category", 'CREATE')
    this.isdesignationaddmode= this.loginService.fnCheckUserRoleAction("Designation", 'CREATE')
    this.isdepartmentaddmode= this.loginService.fnCheckUserRoleAction("Department", 'CREATE')
    this.isgradeaddmode= this.loginService.fnCheckUserRoleAction("Grade", 'CREATE')
    this.isbranchaddmode= this.loginService.fnCheckUserRoleAction("Branch", 'CREATE')
    this.issponseraddmode= this.loginService.fnCheckUserRoleAction("Sponser", 'CREATE')
    this.isaccomtypeaddmode= this.loginService.fnCheckUserRoleAction("AccomType", 'CREATE')
    this.islocationaddmode= this.loginService.fnCheckUserRoleAction("Location", 'CREATE')
    this.ishiresourceaddmode= this.loginService.fnCheckUserRoleAction("HiResource", 'CREATE')
    this.ispaymodeaddmode= this.loginService.fnCheckUserRoleAction("PayMode", 'CREATE')
    this.ispayrollgrpaddmode= this.loginService.fnCheckUserRoleAction("PayrollGroup", 'CREATE')
    this.ispaytypeaddmode= this.loginService.fnCheckUserRoleAction("PayType", 'CREATE')
    this.iswpsgroupaddmode= this.loginService.fnCheckUserRoleAction("WpsGroup", 'CREATE')
    this.isbankbranchaddmode= this.loginService.fnCheckUserRoleAction("BankBranch", 'CREATE')

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  ngAfterViewInit(): void {
    //   this.inputEl.nativeElement.focus();
  }

  fnInitializeFormGroup() {
    this.empform.setValue({
      empid: 0,
      empcode: 'New',
      empname: '',
      fathername: '',
      mothername: '',
      spousename: '',
      presentaddress: '',
      mobile: '',
      altmobile: '',
      permanantaddress: '',
      permcontactnum: '',
      relationname: '',
      relationmobile: '',
      emailid: '',
      staffcode: '',
      lastname: '',
      personalemailid: '',
      recommandby: '',
      remarks: '',
      passportnumber: '',
      visanumber: '',
      emiratesid: '',
      bankaccno: '',
      iban: '',
      labourid: '',
      personcode: '',
      accomdetails: '',
      joindt: null,
      probationdt: null,
      relievedt: null,
      dob: null,
      confirmdt: null,
      passportexpdt: null,
      visaexpdt: null,
      emiratesidexpdt: null,
      labourexpdt: null,
      genderid: null,
      maritalstatusid: null,
      nationalityid: null,
      relationshipid: null,
      paymodeid: null,
      payrollgrpid: null,
      emptypeid: null,
      relievetypeid: null,
      departmentid: null,
      designationid: null,
      gradeid: null,
      branchid: null,
      locationid: null,
      religionid: null,
      bloodgroupid: null,
      sponserid: null,
      contracttypeid: null,
      categoryid: null,
      paytypeid: null,
      wpsgroupid: null,
      bankid: null,
      reportingmanagerid: null,
      approvalmanagerid: null,
      noticeperiod: null,
      statusid: null,
      leavepolicyid: null,
      salutionid: null,
      hiresourceid: null,
      accomtypeid: null,
      obdate: null,
      albalance: null,
      lpbalance: null,
      airticketbalance: null,
      lpamount: null,
      airticketamount: null,
      isesi: false,
      ispf: false,
      isprofessionaltax: false,
      istds: false,
      bankbranchid: null,
      esino: '',
      pfno: '',
      tdsno: '',
      panno: '',
      emppic: '',
      empimage: null,
      expensepolicyid: null,
      visadesignationid: null,
      isdraft:false,
      inactive: false
    })
  }

  fnLoadMaster() {
    this.fngetGender();
    this.fngetMaritalStatus();
    this.fngetRelationship();
    this.fngetPaymode();
    this.fngetPayrollgrp();
    this.fngetEmpType();
    this.fngetRelieveType();
    this.fngetDesignation();
    this.fngetDepartment();
    this.fngetGrade();
    this.fngetBranch();
    this.fngetLocation();
    this.fngetNationality();
    this.fngetRegion();
    this.fngetBloodGroup();
    this.fngetSponser();
    this.fngetContractType();
    this.fngetCategory();
    this.fngetPayType();
    this.fngetWpsGroup();
    this.fngetBankBranch();
    this.fngetReportingManager();
    this.fngetApprovalManager();
    this.fngetStatus();
    this.fngetLeavePolicy();
    this.fngetAccomType();
    this.fngetHiResource();
    this.fngetSalution();
    this.fngetSettings();
    this.fngetExpensePolicy();

  }

  //Get Master
  fngetGender() {
    var data = {
      'genderid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getGender(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.genderColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetMaritalStatus() {
    var data = {
      'maritalstatusid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getMaritalStatus(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.maritalstatusColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetRelationship() {
    var data = {
      'relationshipid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getRelationship(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.relationshipColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetPaymode() {
    var data = {
      'paymodeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getPayMode(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.paymodeColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetPayrollgrp() {
    var data = {
      'payrollgrpid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getPayrollgrp(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.payrollgrpColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetEmpType() {
    var data = {
      'emptypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getEmpType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.emptypeColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetRelieveType() {
    var data = {
      'relievetypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getRelieveType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.relievetypeColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetDepartment() {
    var data = {
      'departmentid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getDepartment(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.departmentColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetDesignation() {
    var data = {
      'designationid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getDesignation(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.designationColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fngetGrade() {
    var data = {
      'gradeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getGrade(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.gradeColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetBranch() {
    var data = {
      'branchid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getBranch(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.branchColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetLocation() {
    var data = {
      'locationid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getLocation(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.locationColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetNationality() {
    var data = {
      'nationalityid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getNationality(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.nationalityColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fngetRegion() {
    var data = {
      'religionid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getReligion(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.religionColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetBloodGroup() {
    var data = {
      'bloodgroupid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getBloodGroup(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.bloodgroupColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetSponser() {
    var data = {
      'sponserid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getSponser(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.sponserColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetContractType() {
    var data = {
      'contracttypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getContractType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.contracttypeColl = res.json().result;
            console.log(this.contracttypeColl)
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetCategory() {
    var data = {
      'categoryid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getCategory(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.categoryColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetPayType() {
    var data = {
      'paytypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getPayType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.paytypeColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetWpsGroup() {
    var data = {
      'wpsgroupid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getWpsGroup(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.wpsgroupColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetBankBranch() {
    var data = {
      'bankbranchid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getBankbranch(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.bankbranchColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetReportingManager() {
    var data = {
      'empid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getEmpListView(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.reportingmanagerColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetApprovalManager() {
    var data = {
      'empid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getEmpListView(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.approvalmanagerColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetStatus() {
    var data = {
      'statusid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getStatus(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.statusColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetLeavePolicy() {
    var data = {
      'leavepolicyid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getLeavePolicyListview(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.leavepolicyColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetAccomType() {
    var data = {
      'accomtypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getAccomType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.accomtypeColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fngetHiResource() {
    var data = {
      'hiresourceid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getHiResource(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.hiresourceColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fngetSalution() {
    var data = {
      'salutionid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getSalution(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.salutionColl = res.json().result;
            if (this.empid === 0 && this.salutionColl.length) {
              this.empform.patchValue({ salutionid: this.salutionColl[0].salutionid });

            }

          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetSettings() {
    var data = {
      'settingsid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getSettings(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.settingsColl = res.json().result[1];
            for (let row of this.settingsColl) {


              if (row.settingsname === 'ENABLE ESI' && row.settingsvalue === '1') {

                this.isesi = true;

              }
              if (row.settingsname === 'ENABLE TDS' && row.settingsvalue === '1') {

                this.istds = true;

              }
              if (row.settingsname === 'ENABLE PF' && row.settingsvalue === '1') {

                this.ispf = true;

              }

              if (row.settingsname === 'ENABLE PROFESSIONAL TAX' && row.settingsvalue === '1') {

                this.isprofessionaltax = true;

              }
            }
          }
          else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fngetExpensePolicy() {
    var data = {
      'expensepolicyid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getExpensepolicyListview(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.expensepolicyColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  
  fngetNextPrevious(actiontype) {

    var data = {
      'empid': this.empid,
      'actiontype': actiontype,
    }
    this.appService.getEmpNextPrevious(data).
      subscribe((res) => {
        if (res.json().status === 200) {
          var _returnemp = res.json().result[0][0].returnemp;
          this.fnEditForm(_returnemp);
        }
      });
  }


  //Get 
  fngetEmp() {
    var data = {
      'empid': this.empid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getEmp(data)
      .subscribe(
        (res) => {
         
          if (res.json().status === 200) {
            var _res = res.json().result;
            var i = 0;
            this.empColl = _res[0];
            this.emppayColl = _res[1];
            this.empdocumentColl = _res[2];
            this.empassetColl = _res[3];
            this.empskillsColl = _res[4];

            this.emploanColl = _res[5];
            this.empadvanceColl = _res[6];
            this.empbonusColl= _res[7];
            this.empreimburseColl= _res[8];
            this.emptransferColl= _res[9];
            this.empfineColl = _res[10];       

            this.emptemptransferColl = _res[11];           
            if (this.emptemptransferColl.length > 0) {
              this.emptemptransferBO = this.emptemptransferColl[0]        
            }

            this.empstatusColl = _res[12];  
            console.log('SATUS LOG')
            console.log(this.empstatusColl)
            if (this.empstatusColl.length > 0) {
              this.empstatusBO = this.empstatusColl[0]        
            }



            var editdata = this.empColl[0];
            this.empBO = editdata;
            this.fnEditMode(editdata);


          }
          else {
            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fnSaveAsDraftBtnClick() {
    this.empform.patchValue({'isdraft':true});
    this.fnSaveBtnClick();
  }
  //Save Btn Click
  fnSaveBtnClick() {
    try {
      //ESI,PF,TDS Check
      this.fnSetValidFieldDynamically();

      this.submitted = true;
      this.successfully = false;

      if (this.loginService.fnCheckFornControlNotfound(this.empform.get('confirmdt'))) {
        this.empform.controls['confirmdt'].setErrors(null);
      }

      //Validate
      if (this.empform.valid) {
        if (this.empform.get('confirmdt').value !== null && this.empform.get('joindt').value !== null) {
          if (this.loginService.fnCompareDateValidation(this.empform.get('confirmdt').value, this.empform.get('joindt').value)) {
            this.empform.controls['confirmdt'].setErrors({ 'notfound': true });
            return
          }
        }

        //Check
        var data = {
          empid: this.empid,
          empcode: this.empform.get('empcode').value,
          empname: this.empform.get('empname').value,
          fathername: this.empform.get('fathername').value,
          mothername: this.empform.get('mothername').value,
          spousename: this.empform.get('spousename').value,
          presentaddress: this.empform.get('presentaddress').value,
          mobile: this.empform.get('mobile').value,
          altmobile: this.empform.get('altmobile').value,
          permanantaddress: this.empform.get('permanantaddress').value,
          permcontactnum: this.empform.get('permcontactnum').value,
          relationname: this.empform.get('relationname').value,
          relationmobile: this.empform.get('relationmobile').value,
          emailid: this.empform.get('emailid').value,
          staffcode: this.empform.get('staffcode').value,
          lastname: this.empform.get('lastname').value,
          personalemailid: this.empform.get('personalemailid').value,
          recommandby: this.empform.get('recommandby').value,
          remarks: this.empform.get('remarks').value,
          passportnumber: this.empform.get('passportnumber').value,
          visanumber: this.empform.get('visanumber').value,
          emiratesid: this.empform.get('emiratesid').value,
          bankaccno: this.empform.get('bankaccno').value,
          iban: this.empform.get('iban').value,
          labourid: this.empform.get('labourid').value,
          personcode: this.empform.get('personcode').value,
          accomdetails: this.empform.get('accomdetails').value,
          joindt: this.fnFormatDatetime(this.empform.get('joindt').value),
          probationdt: this.fnFormatDatetime(this.empform.get('probationdt').value),
          relievedt: this.fnFormatDatetime(this.empform.get('relievedt').value),
          dob: this.fnFormatDatetime(this.empform.get('dob').value),
          confirmdt: this.fnFormatDatetime(this.empform.get('confirmdt').value),
          passportexpdt: this.fnFormatDatetime(this.empform.get('passportexpdt').value),
          visaexpdt: this.fnFormatDatetime(this.empform.get('visaexpdt').value),
          emiratesidexpdt: this.fnFormatDatetime(this.empform.get('emiratesidexpdt').value),
          labourexpdt: this.fnFormatDatetime(this.empform.get('labourexpdt').value),
          genderid: this.empform.get('genderid').value,
          maritalstatusid: this.empform.get('maritalstatusid').value,
          nationalityid: this.empform.get('nationalityid').value,
          relationshipid: this.empform.get('relationshipid').value,
          paymodeid: this.empform.get('paymodeid').value,
          payrollgrpid: this.empform.get('payrollgrpid').value,
          emptypeid: this.empform.get('emptypeid').value,
          relievetypeid: this.empform.get('relievetypeid').value,
          designationid: this.empform.get('designationid').value,
          departmentid: this.empform.get('departmentid').value,
          gradeid: this.empform.get('gradeid').value,
          branchid: this.empform.get('branchid').value,
          locationid: this.empform.get('locationid').value,
          religionid: this.empform.get('religionid').value,
          bloodgroupid: this.empform.get('bloodgroupid').value,
          sponserid: this.empform.get('sponserid').value,
          contracttypeid: this.empform.get('contracttypeid').value,
          categoryid: this.empform.get('categoryid').value,
          paytypeid: this.empform.get('paytypeid').value,
          wpsgroupid: this.empform.get('wpsgroupid').value,
          bankid: this.empform.get('bankid').value,
          reportingmanagerid: this.empform.get('reportingmanagerid').value,
          approvalmanagerid: this.empform.get('approvalmanagerid').value,
          noticeperiod: this.empform.get('noticeperiod').value,
          statusid: this.empform.get('statusid').value,
          leavepolicyid: this.empform.get('leavepolicyid').value,
          salutionid: this.empform.get('salutionid').value,
          hiresourceid: this.empform.get('hiresourceid').value,
          accomtypeid: this.empform.get('accomtypeid').value,
          obdate: this.fnFormatDatetime(this.empform.get('obdate').value),
          albalance: this.empform.get('albalance').value,
          lpbalance: this.empform.get('lpbalance').value,
          airticketbalance: this.empform.get('airticketbalance').value,
          lpamount: this.empform.get('lpamount').value,
          airticketamount: this.empform.get('airticketamount').value,
          isesi: this.empform.get('isesi').value,
          ispf: this.empform.get('ispf').value,
          isprofessionaltax: this.empform.get('isprofessionaltax').value,
          istds: this.empform.get('istds').value,
          bankbranchid: this.empform.get('bankbranchid').value,
          esino: this.empform.get('esino').value,
          pfno: this.empform.get('pfno').value,
          tdsno: this.empform.get('tdsno').value,
          panno: this.empform.get('panno').value,
          empimage: this.strImage,
          emppic: this.picurl,
          isdraft: this.empform.get('isdraft').value,
          inactive: this.empform.get('inactive').value,
          companyid: this.loginService.fnGetCompanyId(),
          emppaycoll: this.emppayColl,
          empdocumentscoll: this.empdocumentColl,
          empassetcoll: this.empassetColl,
          empskillscoll: this.empskillsColl,
          expensepolicyid: this.empform.get('expensepolicyid').value,
          visadesignationid: this.empform.get('visadesignationid').value,
        }

        this.appService.fnCheckEmp(data).subscribe(
          (res) => {
            if (res.json().status === 200) {
              var _checkresult = res.json().result[0].checkfield;

              if (_checkresult === "done") {
                if (this.empform.get('empid').value > 0) {
                  //Update 
                  this.fnSetEmp(data);
                }
                else {
                  //Insert 
                  this.fnInsertEmp(data);
                }
              }
              else {
                if (_checkresult === "name") {
                  this.empform.controls['staffcode'].setErrors({ 'notfound': true });
                }
              }
            }
            else {
              this.loginService.fnAPIError(res.json())
            }
          },
          (err) => {
            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertEmp(data) {

    this.appService.fnInsertEmp(data).subscribe(
      (res) => {
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The new emp has been added successfully.Insert Successfully");
            this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetEmp(data) {

    this.appService.fnSetEmp(data).subscribe(
      (res) => {
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The emp has been updated successfully.");

            this.fnInsertActivityLog('EDIT', this.empid, data.staffcode + " - " + data.empname);

            //this.fnCloseForm();
            this.fngetEmp();
            this.editformtype = "";

            this.submitted = false;
            this.successfully = false;
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }


  fnSetValidFieldDynamically() {

    var isesi = this.empform.get('isesi').value;
    var ispf = this.empform.get('ispf').value;
    var istds = this.empform.get('istds').value;

    if (isesi) {
      this.empform.controls['esino'].setValidators(Validators.required);
    } else {
      this.empform.controls['esino'].clearValidators();
      this.empform.controls['esino'].setErrors(null);
      this.empform.controls['esino'].setValidators(null);
    }

    if (ispf) {
      this.empform.controls['pfno'].setValidators(Validators.required);
    } else {
      this.empform.controls['pfno'].clearValidators();
      this.empform.controls['pfno'].setErrors(null);
      this.empform.controls['pfno'].setValidators(null);
    }


    if (istds) {
      this.empform.controls['tdsno'].setValidators(Validators.required);
    } else {
      this.empform.controls['tdsno'].clearValidators();
      this.empform.controls['tdsno'].setErrors(null);
      this.empform.controls['tdsno'].setValidators(null);
    }


  }

  //Employee Pay
  fnAddEmpPay(type) {
    const modalRef = this.productFindService.open(EmppayComponent, { size: <any>'l' });

    modalRef.componentInstance.paytype = type;
    modalRef.componentInstance.fnUpdatePayType();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      const index = this.emppayColl.findIndex(sku => sku.allowanceid === receivedEntry.allowanceid);

      receivedEntry.empid = this.empid;
      receivedEntry.modifiedby = this.loginService.fnGetModUserId();
      this.fnInsertEmpPay(receivedEntry);

      //this.emppayColl.push(receivedEntry);    

    });
  }

  fnEditEmpPay(index, type) {

    const modalRef = this.productFindService.open(EmppayComponent, { size: <any>'l' });

    modalRef.componentInstance.emppayid = this.emppayColl[index].emppayid;
    modalRef.componentInstance.allowanceid = this.emppayColl[index].allowanceid;
    modalRef.componentInstance.deductionid = this.emppayColl[index].deductionid;
    modalRef.componentInstance.amount = this.emppayColl[index].amount;
    modalRef.componentInstance.isexcludedfromwps = this.emppayColl[index].isexcludedfromwps;
    modalRef.componentInstance.paytype = type;
    modalRef.componentInstance.fnUpdatePayType();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      //this.emppayColl[index]=receivedEntry;    
      //this.emppayColl[index].isedit=1;
      receivedEntry.empid = this.empid;
      receivedEntry.modifiedby = this.loginService.fnGetModUserId();
      this.fnUpdateEmpPay(receivedEntry);
    });
  }

  fnDeleteEmpPayConfirm(index) {
    try {
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete emp pay?')
        .then((confirmed) => {
          if (confirmed) {
            this.fnDeleteEmpPay(this.emppayColl[index]);
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }




  fnInsertEmpPay(data) {

    this.appService.fnInsertEmpPay(data).subscribe(
      (res) => {
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.fnInsertActivityLogInner('EmployeePay', 'INSERT', this.empid, data.allowanceid + " - " + data.deductionid);
            this.fngetEmp();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });
  }

  fnUpdateEmpPay(data) {
    this.appService.fnSetEmpPay(data).subscribe(
      (res) => {
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.fnInsertActivityLogInner('EmployeePay', 'EDIT', this.empid, data.allowanceid + " - " + data.deductionid);
            this.fngetEmp();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });
  }

  fnDeleteEmpPay(data) {
    this.appService.fnDeleteEmpPay(data).subscribe(
      (res) => {
        if (res.json().status === 200) {
          if (res.json().result != "") {

            this.fnInsertActivityLogInner('EmployeePay', 'DELETE', this.empid, data.allowanceid + " - " + data.deductionid);
            this.fngetEmp();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });
  }



  //Employee Document
  fnAddEmpDocument() {
    const modalRef = this.productFindService.open(EmpdocumentComponent, { size: <any>'l' });


    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      const index = this.empdocumentColl.findIndex(sku => sku.doctypeid === receivedEntry.doctypeid);
      receivedEntry.issuedt = this.fnFormatDatetime(receivedEntry.issuedt);
      receivedEntry.expirydt = this.fnFormatDatetime(receivedEntry.expirydt);
      this.empdocumentColl.push(receivedEntry);

    });
  }

  fnEditEmpDocument(index) {

    const modalRef = this.productFindService.open(EmpdocumentComponent, { size: <any>'l' });

    modalRef.componentInstance.empdocumentid = this.empdocumentColl[index].empdocumentid;
    modalRef.componentInstance.doctypeid = this.empdocumentColl[index].doctypeid;
    modalRef.componentInstance.docnum = this.empdocumentColl[index].docnum;
    modalRef.componentInstance.issuedt = this.fnConvertDatetime(this.fnFormatDatetime(this.empdocumentColl[index].issuedt));
    modalRef.componentInstance.expirydt = this.fnConvertDatetime(this.fnFormatDatetime(this.empdocumentColl[index].expirydt));
    modalRef.componentInstance.descr = this.empdocumentColl[index].descr;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      receivedEntry.issuedt = this.fnFormatDatetime(receivedEntry.issuedt);
      receivedEntry.expirydt = this.fnFormatDatetime(receivedEntry.expirydt);
      this.empdocumentColl[index] = receivedEntry;
      this.empdocumentColl[index].isedit = 1;
    });
  }

  fnDeleteEmpDocument(index) {
    try {
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete emp document?')
        .then((confirmed) => {
          if (confirmed) {
            if (this.empdocumentColl[index].empdocumentid === 0) {
              this.empdocumentColl.splice(index, 1);
            }
            else {
              this.empdocumentColl[index].isdelete = 1;
            }
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


  //Employee Asset
  fnAddEmpAsset() {
    const modalRef = this.productFindService.open(EmpassetComponent, { size: <any>'l' });


    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      const index = this.empassetColl.findIndex(sku => sku.assetid === receivedEntry.assetid);
      receivedEntry.givendt = this.fnFormatDatetime(receivedEntry.givendt);
      receivedEntry.expertreturndt = this.fnFormatDatetime(receivedEntry.expertreturndt);
      receivedEntry.returndt = this.fnFormatDatetime(receivedEntry.returndt);
      receivedEntry.empid = this.empid;
      receivedEntry.modifiedby = this.loginService.fnGetModUserId();
      this.fnInsertEmpAsset(receivedEntry);
      //this.empassetColl.push(receivedEntry);    



    });
  }

  fnEditEmpAsset(index) {

    const modalRef = this.productFindService.open(EmpassetComponent, { size: <any>'l' });

    modalRef.componentInstance.empassetid = this.empassetColl[index].empassetid;
    modalRef.componentInstance.assetid = this.empassetColl[index].assetid;
    modalRef.componentInstance.givendt = this.fnConvertDatetime(this.fnFormatDatetime(this.empassetColl[index].givendt));
    modalRef.componentInstance.expertreturndt = this.fnConvertDatetime(this.fnFormatDatetime(this.empassetColl[index].expertreturndt));
    modalRef.componentInstance.returndt = this.fnConvertDatetime(this.fnFormatDatetime(this.empassetColl[index].returndt));
    modalRef.componentInstance.descr = this.empassetColl[index].descr;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      receivedEntry.givendt = this.fnFormatDatetime(receivedEntry.givendt);
      receivedEntry.expertreturndt = this.fnFormatDatetime(receivedEntry.expertreturndt);
      receivedEntry.returndt = this.fnFormatDatetime(receivedEntry.returndt);
      receivedEntry.modifiedby = this.loginService.fnGetModUserId();
      // this.empassetColl[index]=receivedEntry;    
      // this.empassetColl[index].isedit=1;

      receivedEntry.empid = this.empid;
      this.fnUpdateEmpAsset(receivedEntry);

    });
  }

  fnDeleteEmpAssetConfim(index) {
    try {
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete emp asset?')
        .then((confirmed) => {
          if (confirmed) {
            this.fnDeleteEmpAsset(this.empassetColl[index])
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnEditEmpAssetReturn(index) {

    const modalRef = this.productFindService.open(EmpassetComponent, { size: <any>'l' });

    modalRef.componentInstance.empassetid = this.empassetColl[index].empassetid;
    modalRef.componentInstance.assetid = this.empassetColl[index].assetid;
    modalRef.componentInstance.givendt = this.fnConvertDatetime(this.fnFormatDatetime(this.empassetColl[index].givendt));
    modalRef.componentInstance.expertreturndt = this.fnConvertDatetime(this.fnFormatDatetime(this.empassetColl[index].expertreturndt));
    modalRef.componentInstance.returndt = this.fnConvertDatetime(this.fnFormatDatetime(this.empassetColl[index].returndt));
    modalRef.componentInstance.descr = this.empassetColl[index].descr;
    modalRef.componentInstance.formtype = "RETURN";

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      receivedEntry.returndt = this.fnFormatDatetime(receivedEntry.returndt);
      receivedEntry.empid = this.empid;
      receivedEntry.modifiedby = this.loginService.fnGetModUserId();
      this.fnUpdateEmpAssetReturn(receivedEntry);

    });
  }


  fnInsertEmpAsset(data) {

    this.appService.fnInsertEmpAsset(data).subscribe(
      (res) => {
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.fnInsertActivityLogInner('EmployeeAsset', 'INSERT', this.empid, data.assetid);
            this.fngetEmp();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });
  }

  fnUpdateEmpAsset(data) {
    this.appService.fnSetEmpAsset(data).subscribe(
      (res) => {
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.fnInsertActivityLogInner('EmployeeAsset', 'EDIT', this.empid, data.assetid);
            this.fngetEmp();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });
  }

  fnDeleteEmpAsset(data) {
    this.appService.fnDeleteEmpAsset(data).subscribe(
      (res) => {
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.fnInsertActivityLogInner('EmployeeAsset', 'DELETE', this.empid, data.assetid);
            this.fngetEmp();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });
  }


  fnUpdateEmpAssetReturn(data) {


    this.appService.fnSetEmpAssetReturn(data).subscribe(
      (res) => {
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.fngetEmp();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });
  }

  //Employee Skills
  fnAddEmpSkills() {
    const modalRef = this.productFindService.open(EmpskillsComponent, { size: <any>'l' });


    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      const index = this.empskillsColl.findIndex(sku => sku.skillsid === receivedEntry.skillsid);
      receivedEntry.completeon = this.fnFormatDatetime(receivedEntry.completeon);
      receivedEntry.empid = this.empid;
      receivedEntry.modifiedby = this.loginService.fnGetModUserId();
      this.fnInsertEmpSkills(receivedEntry);

      //this.empskillsColl.push(receivedEntry);    

    });
  }

  fnEditEmpSkills(index) {

    const modalRef = this.productFindService.open(EmpskillsComponent, { size: <any>'l' });

    modalRef.componentInstance.empskillsid = this.empskillsColl[index].empskillsid;
    modalRef.componentInstance.skillsid = this.empskillsColl[index].skillsid;
    modalRef.componentInstance.institution = this.empskillsColl[index].institution;
    modalRef.componentInstance.completeon = this.fnConvertDatetime(this.fnFormatDatetime(this.empskillsColl[index].completeon));
    modalRef.componentInstance.descr = this.empskillsColl[index].descr;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      receivedEntry.completeon = this.fnFormatDatetime(receivedEntry.completeon);
      receivedEntry.empid = this.empid;
      receivedEntry.modifiedby = this.loginService.fnGetModUserId();
      this.fnUpdateEmpSkills(receivedEntry);
      //this.empskillsColl[index]=receivedEntry;    
      // this.empskillsColl[index].isedit=1;
    });
  }

  fnDeleteEmpSkillsConfirm(index) {
    try {
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete emp skills?')
        .then((confirmed) => {
          if (confirmed) {

            this.fnDeleteEmpSkills(this.empskillsColl[index]);

          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnInsertEmpSkills(data) {

    this.appService.fnInsertEmpSkills(data).subscribe(
      (res) => {
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.fnInsertActivityLogInner('EmployeeSkills', 'INSERT', this.empid, data.skillsid);
            this.fngetEmp();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });
  }

  fnUpdateEmpSkills(data) {
    this.appService.fnSetEmpSkills(data).subscribe(
      (res) => {
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.fnInsertActivityLogInner('EmployeeSkills', 'EDIT', this.empid, data.skillsid);
            this.fngetEmp();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });
  }

  fnDeleteEmpSkills(data) {
    this.appService.fnDeleteEmpSkills(data).subscribe(
      (res) => {
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.fnInsertActivityLogInner('EmployeeSkills', 'DELETE', this.empid, data.skillsid);
            this.fngetEmp();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });
  }
  //AddPaymode
  private fnAddPaymode() {

    const modalRef = this.productFindService.open(AddpaymodepopupComponent, { size: <any>'xl' });

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetPaymode();

      if (receivedEntry > 0) {
        this.empform.patchValue({ paymodeid: receivedEntry })
      }
    });

  }
  //AddPayrollgrp
  private fnAddPayrollgrp() {

    const modalRef = this.productFindService.open(AddpayrolegrppopupComponent, { size: <any>'xl' });

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetPayrollgrp();

      if (receivedEntry > 0) {
        this.empform.patchValue({ payrollgrpid: receivedEntry })
      }
    });

  }

  //AddPaytype
  private fnAddPaytype() {

    const modalRef = this.productFindService.open(AddpaytypepopupComponent, { size: <any>'xl' });

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetPayType();

      if (receivedEntry > 0) {
        this.empform.patchValue({ paytypeid: receivedEntry })
      }
    });

  }

  //AddWpsGroup
  private fnAddWpsGroup() {

    const modalRef = this.productFindService.open(AddwpsgrouppopupComponent, { size: <any>'xl' });

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetWpsGroup();

      if (receivedEntry > 0) {
        this.empform.patchValue({ wpsgroupid: receivedEntry })
      }
    });

  }


  //AddBankBranch
  private fnAddBankBranch() {

    const modalRef = this.productFindService.open(AddbankbranchpopupComponent, { size: <any>'xl' });

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetBankBranch();

      if (receivedEntry > 0) {
        this.empform.patchValue({ bankbranchid:receivedEntry })
      }
    });

  }
   //AddBankBranch
   private fnAddBranch() {

    const modalRef = this.productFindService.open(AddbranchpopupComponent, { size: <any>'xl' });

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetBranch();

      if (receivedEntry > 0) {
        this.empform.patchValue({ branchid:receivedEntry })
      }
    });

  }

//AddHiresource
private fnAddHiresource() {

  const modalRef = this.productFindService.open(AddhiresourcepopupComponent, { size: <any>'xl' });

  modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

    this.fngetHiResource();

    if (receivedEntry > 0) {
      this.empform.patchValue({ hiresourceid:receivedEntry })
    }
  });

}
//AddEmpType
private fnAddEmpType() {

  const modalRef = this.productFindService.open(AddemptypepopupComponent, { size: <any>'xl' });

  modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

    this.fngetEmpType();

    if (receivedEntry > 0) {
      this.empform.patchValue({ emptypeid:receivedEntry })
    }
  });

}
//AddContractType
private fnAddContractType() {

  const modalRef = this.productFindService.open(AddcontracttypepopupComponent, { size: <any>'xl' });

  modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

    this.fngetContractType();

    if (receivedEntry > 0) {
      this.empform.patchValue({ contracttypeid:receivedEntry })
    }
  });

}

//AddCategory
private fnAddCategory() {

  const modalRef = this.productFindService.open(AddcategorypopupComponent, { size: <any>'xl' });

  modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

    this.fngetCategory();

    if (receivedEntry > 0) {
      this.empform.patchValue({ categoryid:receivedEntry })
    }
  });

}

//AddDepartment
private fnAddDepartment() {

  const modalRef = this.productFindService.open(AdddepartmentpopupComponent, { size: <any>'xl' });

  modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

    this.fngetDepartment();

    if (receivedEntry > 0) {
      this.empform.patchValue({ departmentid:receivedEntry })
    }
  });

}

//AddDesignation
private fnAddDesignation() {

  const modalRef = this.productFindService.open(AdddesignationpopupComponent, { size: <any>'xl' });

  modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

    this.fngetDesignation();

    if (receivedEntry > 0) {
      this.empform.patchValue({ visadesignationid:receivedEntry })
    }
  });

}

//AddGrade
private fnAddGrade() {

  const modalRef = this.productFindService.open(AddgradepopupComponent, { size: <any>'xl' });

  modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

    this.fngetGrade();

    if (receivedEntry > 0) {
      this.empform.patchValue({ gradeid:receivedEntry })
    }
  });

}

//AddLocation
private fnAddLocation() {

  const modalRef = this.productFindService.open(AddlocationpopupComponent, { size: <any>'xl' });

  modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

    this.fngetLocation();

    if (receivedEntry > 0) {
      this.empform.patchValue({ locationid:receivedEntry })
    }
  });

}

//AddSponser
private fnAddSponser() {

  const modalRef = this.productFindService.open(AddsponserpopupComponent, { size: <any>'xl' });

  modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

    this.fngetSponser();

    if (receivedEntry > 0) {
      this.empform.patchValue({ sponserid:receivedEntry })
    }
  });

}

//AddAccomtype
private fnAddAccomtype() {

  const modalRef = this.productFindService.open(AddaccomtypepopupComponent, { size: <any>'xl' });

  modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

    this.fngetAccomType();

    if (receivedEntry > 0) {
      this.empform.patchValue({ accomtypeid:receivedEntry })
    }
  });

}

  //Employee Pop
  fnAddEmpPop(empformtype) {

    this.editformtype = empformtype;

    // const modalRef = this.productFindService.open(AddemppopComponent, { size: <any>'xl' });

    // modalRef.componentInstance.empid = this.empid;
    // modalRef.componentInstance.fngetEmp();
    // modalRef.componentInstance.empformtype = empformtype;    
    // modalRef.componentInstance.strImage = this.strImage;    
    // modalRef.componentInstance.picurl = this.picurl;    
    // modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
    //   if (receivedEntry === 'DONE') {
    //     this.fngetEmp();
    //   }
    // });
  }

  fnTabHeaderClick(type) {

    this.editformtype = type;


    this.fngetMaritalStatus();

  }

  //Close
  fnCloseForm() {
    try {
      this.ismanualclose = true;
      let navigationExtras: NavigationExtras = {
        queryParams: {
          'designationid': this.filterdesignationid,
          'designationname': this.filterdesignationname,
          'payrollgrpid':this.filterpayrollgrpid,
          'payrollgrpname':this.filterpayrollgrpname,
          'branchid':this.filterbranchid,
          'branchname':this.filterbranchname,
          'departmentid':this.filterdepartmentid,
          'departmentname':this.filterdepartmentname,
          'locationid':this.filterlocationid,
          'locationname':this.filterlocationname,
          'nationalityid':this.filternationalityid,
          'nationalityname':this.filternationalityname,
          // 'status': this.filterstatus,
          // 'fromdate': this.fnFormatDatetime(this.filterfromdate),
          // 'todate': this.fnFormatDatetime(this.filtertodate),
        }
      }


      this.router.navigate(['/Emp'],navigationExtras);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnCloseFormEditForm() {
    this.editformtype = "";

    this.empform.reset();
    this.fnInitializeFormGroup();
    this.fngetEmp();
  }

  @HostListener('window:beforeunload')
  canDeactivate(): any {
    if (this.ismanualclose === true || (this.editformtype === "" || this.editformtype === "EMPASSETINFO"
      || this.editformtype === "EMPDOCUMENTINFO" || this.editformtype === "EMPSKILLINFO")) {
      return true;
    }
    else {
      return false;
    }


    // insert logic to check if there are pending changes here;
    // returning true will navigate without confirmation
    // returning false will show a confirm dialog before navigating away
  }


  //Image Import
  changeListener($event): void {
    try {
      this.readThis($event.target);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  readThis(inputValue: any): void {

    var file: File = inputValue.files[0];
    var myReader: FileReader = new FileReader();

    myReader.onloadend = (e) => {
      this.image = myReader.result;
      this.strImage = this.image.split(',')[1];
    }
    myReader.readAsDataURL(file);
  }

  removeimage() {
    this.image = null;
    this.strImage = null;
    this.picurl = "";
  }

  fnOpenFileBrowser(event: any) {

    event.preventDefault();

    let element: HTMLElement = document.getElementById('image') as HTMLElement;
    element.click();

  }

  //Combo Chnage
  fnGetDesgnationName() {


    if (this.empBO) {
      this.designationname = this.empBO.designationname;
    }
    else {
      this.designationname = "";
    }



  }

  fnGetMaritalStatusName(event) {

    let _maritalstatusid = this.empform.get('maritalstatusid').value;

    const index = this.maritalstatusColl.findIndex(sku => sku.maritalstatusid === _maritalstatusid);

    if (index > -1) {
      this.marritalstatusname = this.maritalstatusColl[index].maritalstatus;
    }
    else {
      this.marritalstatusname = "";
    }

  }

  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }

  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }

  fnscrollTo(section, menuname) {
    this.currentmenu = menuname;

    document.querySelector('#' + section)
      .scrollIntoView();


  }


  private fnEditMode(deptBO) {

    deptBO.joindt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.joindt));
    deptBO.probationdt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.probationdt));
    deptBO.relievedt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.relievedt));
    deptBO.dob = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.dob));
    deptBO.confirmdt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.confirmdt));
    deptBO.passportexpdt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.passportexpdt));
    deptBO.visaexpdt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.visaexpdt));
    deptBO.emiratesidexpdt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.emiratesidexpdt));
    deptBO.labourexpdt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.labourexpdt));
    deptBO.obdate = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.obdate));


    this.empform.patchValue({
      empid: deptBO.empid,
      empcode: deptBO.empcode,
      empname: deptBO.empfirstname,
      fathername: deptBO.fathername,
      mothername: deptBO.mothername,
      spousename: deptBO.spousename,
      presentaddress: deptBO.presentaddress,
      mobile: deptBO.mobile,
      altmobile: deptBO.altmobile,
      permanantaddress: deptBO.permanantaddress,
      permcontactnum: deptBO.permcontactnum,
      relationname: deptBO.relationname,
      relationmobile: deptBO.relationmobile,
      emailid: deptBO.emailid,
      staffcode: deptBO.staffcode,
      lastname: deptBO.lastname,
      personalemailid: deptBO.personalemailid,
      recommandby: deptBO.recommandby,
      remarks: deptBO.remarks,
      passportnumber: deptBO.passportnumber,
      visanumber: deptBO.visanumber,
      emiratesid: deptBO.emiratesid,
      bankaccno: deptBO.bankaccno,
      iban: deptBO.iban,
      labourid: deptBO.labourid,
      personcode: deptBO.personcode,
      accomdetails: deptBO.accomdetails,
      joindt: deptBO.joindt,
      probationdt: deptBO.probationdt,
      relievedt: deptBO.relievedt,
      dob: deptBO.dob,
      confirmdt: deptBO.confirmdt,
      passportexpdt: deptBO.passportexpdt,
      visaexpdt: deptBO.visaexpdt,
      emiratesidexpdt: deptBO.emiratesidexpdt,
      labourexpdt: deptBO.labourexpdt,
      genderid: deptBO.genderid,
      maritalstatusid: deptBO.maritalstatusid,
      nationalityid: deptBO.nationalityid,
      relationshipid: deptBO.relationshipid,
      paymodeid: deptBO.paymodeid,
      payrollgrpid: deptBO.payrollgrpid,
      emptypeid: deptBO.emptypeid,
      relievetypeid: deptBO.relievetypeid,
      departmentid: deptBO.departmentid,
      designationid: deptBO.designationid,
      gradeid: deptBO.gradeid,
      branchid: deptBO.branchid,
      locationid: deptBO.locationid,
      religionid: deptBO.religionid,
      bloodgroupid: deptBO.bloodgroupid,
      sponserid: deptBO.sponserid,
      contracttypeid: deptBO.contracttypeid,
      categoryid: deptBO.categoryid,
      paytypeid: deptBO.paytypeid,
      wpsgroupid: deptBO.wpsgroupid,
      bankid: deptBO.bankid,
      reportingmanagerid: deptBO.reportingmanagerid,
      approvalmanagerid: deptBO.approvalmanagerid,
      noticeperiod: deptBO.noticeperiod,
      statusid: deptBO.statusid,
      leavepolicyid: deptBO.leavepolicyid,
      salutionid: deptBO.salutionid,
      hiresourceid: deptBO.hiresourceid,
      accomtypeid: deptBO.accomtypeid,
      obdate: deptBO.obdate,
      albalance: deptBO.albalance,
      lpbalance: deptBO.lpbalance,
      airticketbalance: deptBO.airticketbalance,
      lpamount: deptBO.lpamount,
      airticketamount: deptBO.airticketamount,
      isesi: deptBO.isesi,
      ispf: deptBO.ispf,
      isprofessionaltax: deptBO.isprofessionaltax,
      istds: deptBO.istds,
      esino: deptBO.esino,
      pfno: deptBO.pfno,
      tdsno: deptBO.tdsno,
      panno: deptBO.panno,
      bankbranchid: deptBO.bankbranchid,
      expensepolicyid: deptBO.expensepolicyid,
      visadesignationid: deptBO.visadesignationid,
      isdraft: deptBO.isdraft,
      inactive: false
    });

    this.picurl = deptBO.empimgurl;

    this.fnGetDesgnationName();


    this.totallowanceamt = 0;
    this.totdeductionamt = 0;
    this.totsalaryamt = 0;

    for (let abo of this.emppayColl) {
      if (abo.allowanceid > 0 && abo.isenablecalc===1) {
        this.totallowanceamt = this.totallowanceamt + abo.amount;
      }
      else if (abo.deductionid > 0 && abo.isenablecalc===1) {
        this.totdeductionamt = this.totdeductionamt + abo.amount;
      }
    }

    this.totsalaryamt = this.totallowanceamt - this.totdeductionamt;


    this.formmode = "Edit";

    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;

    this.fnSetValidFieldDynamically();


  }

  fnEditForm(deptid) {
    try {
      let navigationExtras: NavigationExtras = {
        queryParams: {
          'eid': deptid,
        }
      }

      this.router.navigate(['/EmpView',], navigationExtras).then(() => {

        location.reload();
        this.ngOnInit();

      });



    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }



  fnInsertActivityLogInner(formname, action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }







}
